//
//
//
//
//
//
//
//
//
//
//

// http://www.ui.cn/detail/299633.html
import TabbarIndex from './components/TabbarIndex'

export default {
  name: 'app',
  components: {
    TabbarIndex
  }
}



// WEBPACK FOOTER //
// ./src/App.vue